/* unplugin-vue-components disabled */import script from "./detailDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./detailDialog.vue?vue&type=script&setup=true&lang=js"

import "./detailDialog.vue?vue&type=style&index=0&id=e2c70d78&lang=scss&scoped=true"
import "./detailDialog.vue?vue&type=style&index=1&id=e2c70d78&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2c70d78"]])

export default __exports__